/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../Store/action";
import Message from "../../forms/fields/Message";
import { FiDownload } from "react-icons/fi";
import PDF from '../../../assets/resources/What to Bring to Your Tax Planning Call.pdf'


const TaxCallChecklist = ({
  user,
  setStep,
  questionnaireState,
  license,
  taxpro_allow_appointments,
  isAppointmentBooked,
  isVerify
 }) => {
  const dispatch = useDispatch();
  const [alertMessage, setAlertMessage] = useState({});

  const [profile] = useSelector(
    (state) => [state.dashboard]
  );

  // iOS and Safari ignore the `download` attribute on anchors. Opening the PDF
  // in a new tab keeps the React app alive on mobile devices so the updateProfile
  // API call completes and saves progress without being aborted.
  const isMobileOrSafari = useMemo(() => {
    const ua = window.navigator.userAgent;
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      // iPadOS 13+ reports itself as a Mac, so detect it by touch support.
      (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/i.test(ua);
    const isSafari = /^((?!chrome|crios|fxios|android).)*safari/i.test(ua);
    return isIOS || isAndroid || isSafari;
  }, []);

  const markPdfDownloaded = () => {
    // Send only the flag being changed -- the API merges settings server-side,
    // so spreading a possibly-stale local copy would risk reverting keys set by
    // other onboarding steps.
    dispatch(
      allActions.dashboard.updateProfile({
        uuid: user?.uuid,
        profileObj: { settings: { isPdfDownloaded: true } },
      })
    );
  };

  const handleDownload = () => {
    markPdfDownloaded();

    if (isMobileOrSafari) {
      setAlertMessage({
        show: true,
        text: "Opening your checklist in a new tab. Use the share icon to save it to your device.",
        type: 'Success',
      });
      window.open(PDF, '_blank', 'noopener,noreferrer');
      return;
    }

    const link = document.createElement('a');
    link.href = PDF;
    link.download = 'PreTaxChecklist.pdf';
    document.body.appendChild(link);
    link.click();
    link.remove();

    setAlertMessage({ show: true, text: "Download started successfully!", type:'Success' });
  };

      useEffect(() => {
        if (profile?.state === true) {
          dispatch(allActions.user.ReGetUserData());
        }
      }, [profile.state]);
    
    const handleBack = () => {

    if (questionnaireState?.value !== questionnaireState?.max) {
      setStep(6);
      return;
    }

    if (!license) {
      setStep(5);
      return;
    }

    if (taxpro_allow_appointments && !isAppointmentBooked) {
      setStep(4);
      return;
    }

    if (!isVerify) {
      setStep(3);
      return;
    }

    if (!user?.settings?.isPasswordChanged) {
      setStep(2);
      return;
    }

    setStep(1);
  };

  return (
    <div className="container d-flex flex-column align-items-center text-center mt-2">
      {alertMessage.show && <Message message={alertMessage} />}

      <h3 className="fw-bold text-primary mb-1 fs-2">
        You’re almost there!{" "}
        <span role="img" aria-label="confetti">
          🎉
        </span>
      </h3>
      <p className="mb-3 fs-4" style={{ maxWidth: "400px" }}>
        Complete all steps to get{" "}
        <span className="text-success fw-bold">$100 Off</span> on your first tax
        service
      </p>
      <button
        onClick={handleDownload}
        className="btn text-black fw-bold d-flex gap-3 align-items-center mb-4"
        style={{ background: "#f6b820" }}
      >
        Download Your Pre-Tax Call Checklist
        <FiDownload />
      </button>
      <div className="d-flex justify-content-between w-100">
        <button
          className="btn btn-outline-primary px-4"
          onClick={handleBack}
        >
          ← Back
        </button>
        <button
          className="btn btn-primary px-4"
          onClick={() => setStep((prev) => prev + 1)}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default TaxCallChecklist;
